import React from 'react';
import { Navbar as Nav, NavItem, NavLink } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <Nav bg="dark" variant="dark">
      <NavItem>
        <NavLink as={Link} to="/">Inicio</NavLink>
      </NavItem>
      <NavItem>
        <NavLink as={Link} to="/users">Usuarios</NavLink>
      </NavItem>
      <NavItem>
        <NavLink as={Link} to="/sales">Ventas</NavLink>
      </NavItem>
      <NavItem>
        <NavLink as={Link} to="/payments">Pagos</NavLink>
      </NavItem>
      <NavItem>
        <NavLink as={Link} to="/commissions">Comisiones</NavLink>
      </NavItem>
    </Nav>
  );
};

export default Navbar;